import {
    getUserCookieValue,
    getCookie
} from '../global/_cookies';
import {
    isInternational
} from '../global/_checkForInternational';
import Cookies from 'js-cookie'

export const showMyDillardsWelcome = () => {
    var showAndHide = function(a, b, c) {
            a.show();
            b.hide();
            c.hide();
            $('.mdb-g').show();
        },
        welcomeMessage = function(a, b, c) {
            showAndHide(a, b, c);
            $('.mdb-g').hide();
            if(!isInternational()){
            	$('.mdb-r').show();
            }
        };
    var userInfo = Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : null;
    var wcPersistent = Cookies.get('WC_PERSISTENT') ? Cookies.get('WC_PERSISTENT') : null;
			
    if (userInfo && Cookies.get('WC_USERACTIVITY_'+userInfo.userId))
    	welcomeMessage($('.loggedIn-welcome'), $('.persistent-welcome'), $('.guest-welcome'));
    else if(wcPersistent && userInfo && (wcPersistent.split(',')[0].split('_')[3] ==  userInfo.userId)){     
    	    welcomeMessage($('.persistent-welcome'), $('.loggedIn-welcome'), $('.guest-welcome'));
    } else {
    	showAndHide($('.guest-welcome'), $('.loggedIn-welcome'), $('.persistent-welcome'));
        Cookies.remove('userInfo');
        Cookies.remove('userInfo', { path: '/', domain: '.' + window.location.hostname });
    }
};
